import React from 'react';
import {useField} from 'formik';
import {Input} from '../../../../../../../form/form.jsx';
import {isolateNumbers} from '../../../../../../../../common/actions.js';

const BankSeries = () => {
  const [field, meta, helpers] = useField('bank_series');

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      inputMode="tel"
      placeholder="Серия"
      maxLength={4}
      isValid={isValid}
      onChange={value => helpers.setValue(isolateNumbers(value))}
    />
  );
};

export default BankSeries;
